import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { useState, useEffect } from "react";
import Table from "../Table";
import { useHistory } from "react-router-dom";

const StoryCardPublish = ({
  heading = "Published Stories",
  tableData = [],
  tableHeading = [],
  unpublishStory,
  handleTablePageChange,
  page,
  sizePerPage,
  totalSize,
  isLoading,
}) => {
  const [rowData, setRowData] = useState([]);
  const history = useHistory();

  const handleEditStoryClick = (questionId) => {
    history.push("/dashboard/stories/edit/" + questionId);
  };


  const viewSeriesFormatter = (cell, row) => {
    return (
      <div style={{ textAlign: "center" }} key={row._id}>
        <Button
          color="danger"
          className="waves-effect waves-light"
          style={{ width: "100%" }}
          onClick={() => unpublishStory(row._id)}
        >
          Unpublish
        </Button>
      </div>
    );
  };
  useEffect(() => {
  
    tableHeading.push({
      text: "Publish Sleep Sessions",
      dataField: "publish",
      isDummyField: true,
      headerStyle: { textAlign: "center", width: "10%" },
      formatter: viewSeriesFormatter,
    });
    return () => {
      tableHeading.pop();
    };
  }, []);

  useEffect(() => {
    if (tableData) {
      var output = tableData.map((e, i) => {
        var x = Object.assign({ ...e });
        x.sNo = i + 1 + page * 10 - 10;
        return x;
      });
      setRowData(output);
    }
  }, [tableData]);
  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h3 className="m-0">{heading}</h3>
                  </div>
                </Col>
              </Row>
              <Table 
              rows={rowData}
              columns={tableHeading}
              onTableChange={handleTablePageChange}
              page={page}
              sizePerPage={sizePerPage}
              totalSize={totalSize}
              isLoading={isLoading}
               />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StoryCardPublish;
